import { HausbankFieldTypes } from 'hausbank/inquiry/fields';

type HausbankPasswordFieldTypes = HausbankFieldTypes['personalDataPage']['passwordSection'];

export const mapHausbankPassword = (values: HausbankPasswordFieldTypes) => ({
  password: values.password,
});
